import React from 'react';
import * as types from '../types';
import AdminWelcomeModal from '../types/admin-welcome-modal.component'
import UserExperienceModal from '../types/user-experience-modal.component'

export default class ModalWindowManagerComponent extends React.Component {
    render() {
        return this.props.modals.map(modal => {
            switch (modal.type) {
                case types.TYPE_ADMIN_WELCOME:
                    return <AdminWelcomeModal {...modal} submitModal={this.props.submitModal} key={modal.id}/>
                case types.TYPE_USER_EXPERIENCE:
                    return <UserExperienceModal {...modal} submitModal={this.props.submitModal} declineModal={this.props.declineModal} key={modal.id}/>
            }
        });
    }
}
